var _mask, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9999 0H0V23.9998H23.9999V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.132 20.3588C19.085 20.2058 18.979 20.0768 18.825 20.0258L16.193 19.1498C15.273 18.7668 14.845 17.2958 14.746 16.7058C15.427 16.0728 16.056 15.1298 16.056 14.2778C16.056 13.9888 16.138 13.8768 16.122 13.8738C16.278 13.8348 16.405 13.7228 16.465 13.5738C16.513 13.4518 16.944 12.3528 16.944 11.6118C16.944 11.5708 16.94 11.5298 16.93 11.4898C16.867 11.2388 16.72 10.9868 16.5 10.8278V8.49976C16.5 7.06076 16.062 6.45876 15.598 6.10976C15.494 5.39376 14.728 3.99976 12 3.99976C9.212 3.99976 7.5 6.62076 7.5 8.49976V10.8278C7.28 10.9868 7.133 11.2388 7.07 11.4898C7.061 11.5298 7.056 11.5708 7.056 11.6118C7.056 12.3528 7.487 13.4518 7.536 13.5738C7.595 13.7228 7.675 13.8188 7.831 13.8578C7.862 13.8768 7.944 13.9888 7.944 14.2778C7.944 15.1298 8.573 16.0728 9.255 16.7058C9.155 17.2958 8.732 18.7648 7.842 19.1368L5.175 20.0258C5.022 20.0768 4.913 20.2028 4.865 20.3558C2.504 18.3368 1 15.3428 1 11.9998C1 5.93476 5.935 0.999756 12 0.999756C18.066 0.999756 23 5.93476 23 11.9998C23 15.3448 21.495 18.3398 19.132 20.3588ZM24 11.9998C24 5.38376 18.617 -0.000244141 12 -0.000244141C5.383 -0.000244141 0 5.38376 0 11.9998C0 18.6168 5.383 23.9998 12 23.9998C12.122 23.9998 12.239 23.9858 12.36 23.9818L12.402 23.9898C12.435 23.9968 12.467 23.9998 12.5 23.9998C12.547 23.9998 12.593 23.9938 12.637 23.9808L12.694 23.9648C18.987 23.6028 24 18.3828 24 11.9998Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.1a02afd86bceee3cd7185fbff7a6d44c.svg";
export { ForwardRef as ReactComponent };